/**
 * 消息文件索引
 * 支持通过 HTTP API 请求获取翻译，失败时回退到静态文件
 */
import type { ImplementedLocale } from '../shared'
import { fetchMessagesClient } from './api'

/**
 * 将深层嵌套的对象属性从字面量类型转换为 string 类型
 */
type DeepStringify<T> = {
  [K in keyof T]: T[K] extends object ? DeepStringify<T[K]> : T[K] extends boolean ? boolean : string;
}

// Ensure type references default to the english baseline
export type Messages = DeepStringify<typeof import('./en').default>

/**
 * 静态导入消息（用于回退）
 */
const staticMessageLoaders: Record<ImplementedLocale, () => Promise<{ default: Messages }>> = {
  'zh-CN': () => import('./zh-CN').then(m => m as any),
  'en': () => import('./en').then(m => m as any),
}

/**
 * 动态加载消息
 * 优先从 HTTP API 获取，失败时回退到静态文件
 */
export const messageLoaders: Record<ImplementedLocale, () => Promise<{ default: Messages }>> = {
  'zh-CN': async () => {
    try {
      const messages = await fetchMessagesClient('zh-CN')
      if (!messages?.HomePage)
        throw new Error('Empty zh-CN messages response')
      return { default: messages }
    }
    catch {
      // 回退到静态文件
      return staticMessageLoaders['zh-CN']()
    }
  },
  'en': async () => {
    try {
      const messages = await fetchMessagesClient('en')
      if (!messages?.HomePage)
        throw new Error('Empty English messages response')
      return { default: messages }
    }
    catch {
      // 回退到静态文件
      return staticMessageLoaders.en()
    }
  },
}
